import Dropin from './Dropin';
import { WtaiUploadWidgetProps } from './types';
export default Dropin;
export { WtaiUploadWidgetProps };
export var UploadWidget = Dropin;